import React from 'react';
import { connect } from 'react-redux';
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import Drawer from 'material-ui/Drawer';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import MenuItem from 'material-ui/MenuItem';
import {Link} from 'react-router';
import DropDownMenu from 'material-ui/DropDownMenu';
import {withRouter} from 'react-router';
import {isSignedIn} from '../reducer';
import {handleNewCredentials, signOut} from '../actions/auth';
import SyncIndicator from '../components/SyncIndicator';
import Dialog from 'material-ui/Dialog';
import Avatar from 'material-ui/Avatar';
import md5 from 'js-md5';
import ListItem from 'material-ui/List/ListItem';

class Admin extends React.Component {

  constructor(props) {
    super()
    this.state = {
      drawerOpen: false
    }
    this.togglerDrawer = this.togglerDrawer.bind(this);
    this.handleSectionChange = this.handleSectionChange.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  render() {
    let section = (this.props.section && this.props.section !== 'options') ? this.props.section : "monitoring";
    var title = "FishPath Tool Admin" + this.props.title;
    if (this.props.isOptions) {
      title = (
        <div>
          {title}
          <DropDownMenu style={{marginLeft: -15, marginTop: 4, fontSize: 24, position: 'absolute'}} labelStyle={{color: "white"}} value={section} onChange={this.handleSectionChange}>
            <MenuItem value="monitoring" primaryText="Data Collection" />
            <MenuItem value="assessment" primaryText="Assessment" />
            <MenuItem value="controlRules" primaryText="Management Measures" />
            <MenuItem value="enforcement" primaryText="Enforcement" />
          </DropDownMenu>
        </div>
      )
    }
    return (
      <div>
        <AppBar
          title={title}
          style={{position: "fixed", top:0, backgroundColor: "rgb(102, 112, 130)"}}
          onLeftIconButtonClick={this.togglerDrawer}
        >
        </AppBar>
        <Drawer
          docked={false}
          width={200}
          open={this.state.drawerOpen}
          onRequestChange={this.togglerDrawer}
        >
          {
            this.props.email ? <div>
              <ListItem
                leftAvatar={<Avatar size={35} src={`https://www.gravatar.com/avatar/${md5(this.props.email)}?d=mm`} />}
                style={{
                  padding: "20px 16px 20px 62px",
                  textOverflow: "ellipsis",
                  width: 120,
                  overflow: "hidden",
                  whiteSpace: "nowrap"
                }}
                disabled
              >
                {this.props.name || this.props.email}
              </ListItem>
              <MenuItem style={{paddingLeft: 10}} onClick={this.closeDrawer} containerElement={<Link to="/home" />}>My Fisheries</MenuItem>
              <MenuItem style={{paddingLeft: 10}} onClick={this.signOut} containerElement={<Link to="/" />}>Sign Out</MenuItem>
            </div> : <MenuItem onClick={this.closeDrawer} containerElement={<Link to="/" />}>Login</MenuItem>
          }
          <Divider />
          <Subheader>Admin</Subheader>
          <MenuItem onClick={this.togglerDrawer} containerElement={<Link to="/admin" />}>Summary</MenuItem>
          <MenuItem onClick={this.togglerDrawer} containerElement={<Link to="/admin/questions" />}>Questions</MenuItem>
          <MenuItem onClick={this.togglerDrawer} containerElement={<Link to="/admin/questionOrder" />}>Question Order</MenuItem>
          <MenuItem onClick={this.togglerDrawer} containerElement={<Link to="/admin/options" />}>Options</MenuItem>
          <MenuItem onClick={this.togglerDrawer} containerElement={<Link to="/admin/tags" />}>Tags</MenuItem>
          <MenuItem onClick={this.togglerDrawer} containerElement={<Link to="/admin/exports" />}>Exports</MenuItem>
          {/*<MenuItem onClick={this.togglerDrawer} containerElement={<Link to="/admin/translation" />}>Translations</MenuItem>*/}
        </Drawer>
        <div style={{paddingTop: 80}}>
          {this.props.children}
        </div>
        <Dialog
          title="Not Authorized"
          open={!this.props.isAdmin}
          actions={[
            <RaisedButton primary={true} href="/" label="Okay" />
          ]}
        >
        You must be logged in as an administrator to access this area.
        </Dialog>
        <SyncIndicator isSyncing={this.props.isSyncing} errorMessage={this.props.syncError} />
      </div>
    )
  }

  togglerDrawer() {
    this.setState({drawerOpen: !this.state.drawerOpen});
  }

  handleSectionChange(e, i, value) {
    this.props.router.push("/admin/options/" + value);
  }

  signOut() {
    this.props.signOut();
    this.props.router.push("/");
  }
}

const mapStateToProps = (state, ownProps) => {
  var title = "";
  let path = ownProps.location.pathname;
  if (/questionOrder/.test(path)) {
    title = " / Question Order";
  } else if (/admin\/question/.test(path)) {
    title = " / Questions";
  } else if (/admin\/option/.test(path)) {
    title = " / Options / ";
  } else if (/admin\/exports/.test(path)){
    title = " / Exports";
  }else if (/admin\/translation/.test(path)){
    title = " / Translation";
    if(path.split('/').length > 3){
      title += " / " + state.translationList.find(t => t.id === parseInt(path.split('/')[3])).title
    }
  }
  return {
    isSignedIn: isSignedIn(state),
    title: title,
    isOptions: /admin\/option/.test(path) && !/create/.test(path) && !/edit/.test(path),
    section: ownProps.location.pathname.split("/").slice(-1)[0],
    isSyncing: state.sync.isSyncing,
    syncError: state.sync.syncError,
    isAdmin: state.auth.isAdmin,
    email: state.auth.email,
    name: state.auth.name
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleNewCredentials: (creds) => dispatch(handleNewCredentials(creds)),
    signOut: () => dispatch(signOut())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));
